import { render } from "./SaasRise.vue?vue&type=template&id=3939ea4f&scoped=true"
import script from "./SaasRise.vue?vue&type=script&lang=js"
export * from "./SaasRise.vue?vue&type=script&lang=js"

import "./SaasRise.vue?vue&type=style&index=0&id=3939ea4f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3939ea4f"]])

export default __exports__